import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/common.scss'
import { hasPerm, canAny, isAdmin, isSubAdmin, isEmployee, getUserRole } from '@/utils/permission'
import appConfig, { APP_TITLE } from '@/utils/appConfig'

Vue.use(ElementUI, { locale })
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 99999,
    toolbar: true,
    navbar: true,
    title: true,
    tooltip: true,
    movable: true,
    zoomable: true,
    rotatable: true,
    scalable: true,
    transition: true,
    fullscreen: true
  }
})

// 全局权限工具：模板中直接用 $hasPerm('employee_profile','create')
Vue.prototype.$hasPerm = hasPerm
Vue.prototype.$canAny = canAny
Vue.prototype.$isAdmin = isAdmin
Vue.prototype.$isSubAdmin = isSubAdmin
Vue.prototype.$isEmployee = isEmployee
Vue.prototype.$getUserRole = getUserRole

// 全局应用配置：模板中 {{ $appConfig.APP_TITLE }} / 脚本中 this.$appTitle
Vue.prototype.$appConfig = appConfig
Vue.prototype.$appTitle = APP_TITLE

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
